var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info"},[_vm._m(0),_c('blockSpacList',{attrs:{"list":_vm.list,"labelWidth":"100px"}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("客户信息")])])
}]

export { render, staticRenderFns }